import { Box, Stack, Typography } from '@mui/material'
import { ArrowRightIcon, CheckCircleIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'

import { INTERAX_COLORS } from '../../../../../constants/colors'
import { TESTIDS } from '../../../../../config/testids'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../../interaxDesignSystemComponents'
import { GamerRoutes } from '../../../../../config/routes/routeEnums'
import { CONTINUE_FROM_COACH_GOALS_STATE } from '../../onboardingSteps.config'

/**
 * Offered once the first conversation has produced goals, since nothing else here points back to the
 * remaining onboarding steps. A card the user can ignore, not a redirect — they may want to keep talking.
 */
export const CoachContinueOnboardingCard = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    // `mt: auto` pins the card to the foot of the panel: a plain gap under a full-height chat, and in a
    // spoken mode what stops it floating mid-screen as though it were part of the conversation.
    <Box sx={{ flexShrink: 0, mt: 'auto', pt: 1.5 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row', md: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center', md: 'center' }}
        justifyContent="space-between"
        data-testid={TESTIDS.COACH_CONTINUE_ONBOARDING}
        sx={{
          p: { xs: 1.5, sm: 1.5, md: 2 },
          borderRadius: 2,
          backgroundColor: INTERAX_COLORS.sun20,
          border: `1px solid ${INTERAX_COLORS.sun40}`
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
          <CheckCircleIcon width={20} color={INTERAX_COLORS.sun} />
          <Typography sx={{ color: INTERAX_COLORS.white, fontSize: 14 }}>
            {t('gamer.ariaCoach.goalSetting.continueOnboarding')}
          </Typography>
        </Stack>
        <Button
          variant="primary"
          size="small"
          // The flag lets the onboarding page open the next outstanding step by itself on arrival.
          onClick={() => navigate(GamerRoutes.ONBOARDING, { state: { [CONTINUE_FROM_COACH_GOALS_STATE]: true } })}
          icon={<ArrowRightIcon width={16} />}
          iconPosition="right"
        >
          {t('gamer.ariaCoach.goalSetting.continueOnboardingCta')}
        </Button>
      </Stack>
    </Box>
  )
}
